const customStylesCheckboxButton = {
  root: {
    color: '#c7d2cd',
    borderWidth: 1,
    '&$checked': {
      color: '#4593ea',
    },
  },
  checked: {}
};

export default customStylesCheckboxButton;
